export default __webpack_public_path__ + "static/media/favicon.c3d9dfba.ico";